import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class DownloadFormAgencyService extends BaseService {
  constructor(protected http: HttpClient) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/download_form_agency`);
  }
}
